import { useEffect, useReducer } from "react";
import { set } from "traverse";
import { startOfMonth } from "utils/date";
import { ReactSubscriber } from "utils/ReactSubscriber";

// state for keeping date range btw mounting/unmounting for range date pickers
interface StorageState {
  startDate: Date | undefined;
  endDate: Date | undefined;
  reportDate: Date | undefined;
}

class GlobalDateRange extends ReactSubscriber<StorageState> {
  constructor() {
    super({
      startDate: startOfMonth(new Date()),
      endDate: new Date(),
      reportDate: new Date(),
    });
  }

  setStartDate(newDate: Date | undefined) {
    this.state.startDate = newDate;
    this.updateState();
  }

  setEndDate(newDate: Date | undefined) {
    this.state.endDate = newDate;
    this.updateState();
  }

  setReportDate(newDate: Date | undefined) {
    this.state.reportDate = newDate;
    this.updateState();
  }
}

const globalDateRange = new GlobalDateRange();

export const useGlobalDateRange = () => {
  const [, forceRender] = useReducer((previous) => previous + 1, 0);

  useEffect(() => {
    const index = globalDateRange.subscribe(forceRender);
    return () => globalDateRange.unsubscribe(index);
  }, []);

  return {
    ...globalDateRange.State,
    setStartDate: (newDate: Date | undefined) => {
      globalDateRange.setStartDate(newDate);
    },
    setEndDate: (newDate: Date | undefined) => {
      globalDateRange.setEndDate(newDate);
    },
    setReportDate: (newDate: Date | undefined) => {
      globalDateRange.setReportDate(newDate);
    },
  };
};
